var { GGM3Engine } = require("./engine.js");

module.exports = GGM3Engine;
